import { throttle, isEmpty, cloneDeep, intersection } from "lodash";

const findAllChildren = (source) => {
  const result = [];
  if (isEmpty(source)) {
    return result;
  }
  result.push(source.props.fieldId);
  if (!isEmpty(source.children)) {
    source.children.forEach((item) => result.push(...findAllChildren(item)));
  }
  return result;
};

class ScrollManager {
  constructor({ fieldApi, context, schema }) {
    this.fieldApi = fieldApi;
    this.context = context;
    this.setGroups(schema);
    this.bindScrollHandlers();
  }

  setGroups(schema) {
    const groups = [];
    const recursiveGroups = (children) => {
      const result = [];
      !isEmpty(children) &&
        children.forEach((child) => {
          if (!isEmpty(child.children)) {
            if (child.componentName === "GroupLayout") {
              result.push({
                fieldId: child.props.fieldId,
                name:
                  typeof child.props.title === "object"
                    ? child.props.title.zh_CN
                    : child.props.title,
                isActive: false,
                hasError: false,
                hideOnNav: child.props.hideOnNav,
                subNav: recursiveGroups(child.children),
                // 递归的展示所有的子节点
                children: findAllChildren(child),
              });
            }
          }
        });
      return result;
    };
    schema.pages.forEach((page) => {
      // 递归遍历 Group，但是要过滤掉外层的Group？
      groups.push(...recursiveGroups(page.layout.children));
    });
    if (!isEmpty(groups)) {
      groups[0].isActive = true;
    }
    this.context.setGlobal({ groups });
    this.reportGroups();
  }

  updateGroupError() {
    const errorFieldIds = this.context.getGlobal("errorFieldIds");
    const prevGroups = this.context.getGlobal("groups");
    const groups = cloneDeep(prevGroups);
    if (isEmpty(groups)) {
      return;
    }
    groups.forEach((group) => (group.hasError = false));
    if (!isEmpty(errorFieldIds)) {
      groups.forEach((group) => {
        group.hasError = !isEmpty(intersection(group.children, errorFieldIds));
      });
    }
    if (JSON.stringify(prevGroups) !== JSON.stringify(groups)) {
      this.context.setGlobal({ groups });
      this.reportGroups();
    }
  }

  updateFieldError(fieldId, hasError) {
    const prevErrorFieldIds = this.context.getGlobal("errorFieldIds") || [];
    if (prevErrorFieldIds.includes(fieldId) && hasError) {
      return;
    }
    if (!prevErrorFieldIds.includes(fieldId) && !hasError) {
      return;
    }
    const errorFieldIds = cloneDeep(prevErrorFieldIds);
    // 这里 errorFieldIds 打乱了顺序
    if (hasError) {
      errorFieldIds.push(fieldId);
    } else {
      errorFieldIds.splice(errorFieldIds.indexOf(fieldId), 1);
    }
    this.context.setGlobal({ errorFieldIds });
    const prevGroups = this.context.getGlobal("groups");
    const groups = cloneDeep(prevGroups);
    if (isEmpty(groups)) {
      return;
    }
    const group = groups.find((item) => item.children.includes(fieldId));
    if (!group) {
      // fieldId 不在任何分组的情况
      return;
    }
    group.hasError = !isEmpty(intersection(group.children, errorFieldIds));
    if (JSON.stringify(prevGroups) !== JSON.stringify(groups)) {
      this.context.setGlobal({ groups });
      this.reportGroups();
    }
  }

  reportGroups() {
    const groups = this.context.getGlobal("groups");
    if (isEmpty(groups)) {
      return;
    }
    this.context.emitter.emit("reportGroups", groups);
  }

  // 监听滚动，判断当前位置在那个 Group 区间内，像外层组件发送消息。
  scrollHandler() {
    const prevGroup = this.context.getGlobal("groups");
    const formEl = document.getElementById("GovForm");
    const formNavEl = document.getElementById("govFormNav");
    if (isEmpty(prevGroup) || !formEl || !formNavEl) {
      return;
    }
    const groups = cloneDeep(prevGroup);
    if (isEmpty(groups)) {
      return;
    }
    groups.forEach((group) => (group.isActive = false));
    for (let index = groups.length - 1; index >= 0; index--) {
      const group = groups[index];
      const groupRect = this.fieldApi.getFieldRect(group.fieldId);
      const offsetTop =
        parseInt(formEl.style.paddingTop, 10) || 0 + formNavEl.offsetHeight;
      if (
        groupRect &&
        groupRect.top - offsetTop <= 10 &&
        groupRect.top + groupRect.height > offsetTop
      ) {
        group.isActive = true;
        break;
      }
    }
    if (JSON.stringify(prevGroup) !== JSON.stringify(groups)) {
      this.context.setGlobal({ groups });
      this.reportGroups();
    }
  }

  throttleScrollHandler = throttle(() => {
    this.scrollHandler();
  }, 50);

  bindScrollHandlers() {
    window.removeEventListener("scroll", this.throttleScrollHandler);
    window.addEventListener("scroll", this.throttleScrollHandler);
  }

  bindErrorMsgChangeHandler(fieldId) {
    if (!fieldId) {
      return;
    }
    this.fieldApi.onValidationChange(fieldId, (hasError) => {
      this.updateFieldError(fieldId, hasError);
    });
  }
}

export default ScrollManager;
